<template>
  <div>
    <input
      :id="id"
      :placeholder="placeholder"
      :disabled="disabled"
      v-model="input"
      type="text"
      class="input-tags"
      @value="tags">
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'

export default {
  props: {
    value: {
      type: Array,
    },
    placeholder: {
      type: String,
      default: '',
    },
    delimiter: {
      type: String,
      default: ',',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: [],
    },
    default: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      id: uuid.v1(),
      input: this.value,
      tags: [],
      $selectize: null,
      selectize: null,
    }
  },
  watch: {
    tags () {
      this.$emit('input', this.tags)
    },
    options (after, before) {
      this.selectize.addOption(after)
    },
    default (after, before) {
      this.selectize.setValue(after)
    },
  },
  mounted: function () {
    let t = this
    this.$selectize = $('#' + this.id).selectize({
      render: {
        option_create: function (data, escape) {
          return '<div class="create"><span class="text-success"><i class="fas fa-plus"></i> ' + t.$t('message.addnewproduct') + '</span> <span>' + escape(data.input) + '</span></div>'
        },
      },
      create: true,
      labelField: 'item',
      valueField: 'item',
      delimiter: this.delimiter,
      persist: false,
      create: function (input) {
        return {
          item: input,
        }
      },
      onChange: function (value) {
        let values = value.split(t.delimiter)
        t.tags = values
        // this.blur()
      },
    })
    // set selectize
    this.selectize = this.$selectize[0].selectize

    // set default
    if (this.options) {
      this.selectize.addOption(this.options)
    }

    // set default
    if (this.default) {
      this.tags = this.default
      this.selectize.setValue(this.default)
    }
  },
  methods: {
    convertArray2String (arr) {
      let str = ''
      for (let i in arr) {
        str += arr[i]
        if (i < arr.length - 1) {
          str += this.delimiter
        }
      }
      return str
    },
    clearOptions () {
      this.selectize.clearOptions()
    },
    addOptions (values) {
      for (let i in values) {
        this.selectize.addOption({
          item: values[i],
        })
      }
    },
    setValue (value) {
      this.selectize.setValue(value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/InputTags.vue